import { useRecoverDesktopRecordingAfterReload } from '@/app-shell/desktop/hooks/recoverDesktopRecordingAfterReload';

/**
 * Headless desktop-only post-reload recovery: re-attaches the online-chunk
 * upload listeners and restores FE recording UI state (DSK-695).
 *
 * Mounted once at the app root, outside auth gating, so recovery converges the
 * UI with Rust's still-running recorder before any recording surface renders —
 * but inside `HeidiIntlProvider`, since the hook feeds `useIntl()` to the
 * online-chunk upload toasts.
 */
export const DesktopRecordingRecoveryMount = () => {
  useRecoverDesktopRecordingAfterReload();
  return null;
};
